
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  name: 'App',
  setup() {
    onMounted(() => {
      // 友盟统计添加
      const script = document.createElement('script')
      console.log(process.env.NODE_ENV)
      let id = null
      if (
        process.env.NODE_ENV === 'test' ||
        process.env.NODE_ENV === 'development'
      ) {
        id = 1279994422
      } else if (process.env.NODE_ENV === 'production') {
        id = 1279994426
      }
      script.src = 'https://s9.cnzz.com/z_stat.php?id=' + id + '&web_id=' + id
      script.type = 'text/javascript'
      document.body.appendChild(script)
    })
  },
})
